import React, { useState } from 'react';
import axios from 'axios';
import { URL_API_PRESTADORES } from '../../constantes/urls';
import sweet from 'sweetalert';
import { Typography, Dialog, Button, TextField, Grid, makeStyles, FormControl } from '@material-ui/core';
import './sweet.css';

const useStyles = makeStyles((theme) => ({
    padding: {
        marginTop: 40,
        marginBottom: 40,
    },
    inputs: {
        marginTop: 20,
    },
    button: {
        background: '#3f51b5'
    },
    fonts: {
        fontFamily: "Roboto"
    }
}));

function FormularioPrestador({ open, cerrar }) {
    const styles = useStyles();
    const [prestador, setPrestador] = useState({
        nit: '',
        nombre: '',
        email: ''
    });
    const [activado, setActivado] = useState('outlined');
    const onChange = (e) => {
        const { name, value } = e.target;
        const data = { ...prestador }
        data[name] = value;
        setPrestador(data)
        validar()
    }


    const validar = () => {
        if (prestador.nit && prestador.nombre && prestador.email) {
            setActivado('contained');
        }
    }
    const onSubmit = async () => {

        if (activado !== true) {
            try {
                const respuesta = await axios.post(URL_API_PRESTADORES, prestador)
                if (respuesta.status = 200) {
                    sweet({
                        title: 'Guardado',
                        text: 'Se guardó el registro',
                        icon: 'success',
                        timer: 2000,
                        buttons: false
                    })
                        .then((r) => {
                            cerrar()
                        })
                }
            } catch (error) {
                if (error.response.data.message) {
                    console.log(error)
                    sweet({
                        title: 'Error',
                        text: error.response.data.message,
                        buttons: false,
                        icon: 'error',
                        timer: 2000
                    });
                }
            }
        }
    }
    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            maxWidth="sm"
        >
            <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={styles.padding}
            >
                <Grid item xs={10} md={10} sm={11}>
                    <Typography variant="h6" align="center">
                        Ingrese los datos necesarios para regristrarse
                    </Typography>
                </Grid>
                <Grid item xs={8} md={8} sm={10}>
                    <FormControl fullWidth className={styles.inputs}>
                        <TextField
                            name="nit"
                            required
                            label="NIT"
                            onChange={onChange}
                        />
                    </FormControl>
                    <FormControl fullWidth className={styles.inputs}>
                        <TextField
                            name="nombre"
                            required
                            label="Nombre del prestador"
                            onChange={onChange}
                        />
                    </FormControl>
                    <FormControl fullWidth className={styles.inputs}>
                        <TextField
                            name="email"
                            required
                            label="Correo electrónico"
                            helperText='Si tiene más de uno, debe separarlos por ";" (PUNTO Y COMA)'
                            onChange={onChange}
                        />
                    </FormControl>
                </Grid>
                <Grid item sx={8} md={8} sm={10} className={styles.inputs}>
                    <Grid container direction="row-reverse" alignItems="center" justify="center" spacing={5}>
                        <Grid item>
                            <Button
                                variant={activado}
                                color='primary'
                                onClick={onSubmit}>GUARDAR</Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant='outlined'
                                color='secondary'
                                onClick={cerrar}
                            >CANCELAR</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    )
}

export default FormularioPrestador;